import React, { useState, useEffect, useRef, useCallback} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ProgressBar } from 'primereact/progressbar';
import { Dialog } from 'primereact/dialog';
import { ProductService } from '../service/ProductService';
import { CustomerService } from '../service/CustomerService';

import { collection, getDocs, query, where ,orderBy,limit} from "firebase/firestore";
import { db_firestore } from "../firebase-configure";
import { useAuth } from './../context/AuthContext';
import { useParams } from 'react-router';
import isMobile from './tools/DeviceInfo';


export const Recibos = () => {

    const [customer1, setCustomer1] = useState(null);
    const [customer2, setCustomer2] = useState(null);
    const [customer3, setCustomer3] = useState(null);
    const [selectedCustomers, setSelectedCustomers] = useState(null);
    const [globalFilter1, setGlobalFilter1] = useState('');
    const [globalFilter2, setGlobalFilter2] = useState('');
    const [loading1, setLoading1] = useState(true);
    const [loading2, setLoading2] = useState(true);
    const [products, setProducts] = useState(null);
    const [expandedRows, setExpandedRows] = useState([]);
    const toast = useRef(null);
    const {myUser} = useAuth();
    let {anio} = useParams();


    const [recibos, setRecibos] = useState([]);
    const [reciboDialogVisible, setReciboDialogVisible] = useState(false);
    const [reciboSeleccionado, setReciboSeleccionado] = useState('');
    const pedidoReciboRef = useRef(0);

    const verRecibo = async (url) => {
        // Celular: es un equipo personal, lo abre el visor propio del navegador.
        if (isMobile.any()) {
            window.open(url, '_blank', 'noreferrer');
            return;
        }

        // PC: es una terminal compartida, así que mostramos el PDF a través de una blob
        // URL para que la dirección real del recibo no quede en el historial del navegador.
        const pedido = ++pedidoReciboRef.current;
        setReciboSeleccionado('');
        setReciboDialogVisible(true);

        try {
            const response = await fetch(url);
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);

            if (pedidoReciboRef.current !== pedido) {
                URL.revokeObjectURL(blobUrl);
                return;
            }

            setReciboSeleccionado(blobUrl);
        } catch (err) {
            if (pedidoReciboRef.current === pedido) {
                setReciboSeleccionado(url);
            }
        }
    };

    const cerrarRecibo = () => {
        pedidoReciboRef.current++;

        if (reciboSeleccionado.startsWith('blob:')) {
            URL.revokeObjectURL(reciboSeleccionado);
        }

        setReciboDialogVisible(false);
        setReciboSeleccionado('');
    };

    useEffect(() => {

        const getRecibos = async () => {
            setLoading1(true);
            const querySnapshot = await getDocs(query(collection(db_firestore, "recibos"),where("cuil","==",myUser.cuil),where ("año","==",anio)));

            setRecibos(querySnapshot.docs.map((doc) => ({...doc.data(), id:doc.id})));
            setLoading1(false);
        }

        getRecibos();
    }, [anio,myUser.cuil])


    useEffect(() => {
        const customerService = new CustomerService();
        const productService = new ProductService();
        productService.getProductsWithOrdersSmall().then(data => setProducts(data));
        customerService.getCustomersMedium().then(data => { setCustomer1(data); setLoading1(false) });
        customerService.getCustomersMedium().then(data => { setCustomer2(data); setLoading2(false) });
        customerService.getCustomersMedium().then(data => setCustomer3(data));
    }, []);


    const expandAll = () => {
        let _expandedRows = {}
        products.forEach(p => _expandedRows[`${p.id}`] = true);

        setExpandedRows(_expandedRows);
        toast.current.show({ severity: 'success', summary: 'All Rows Expanded', life: 3000 });
    };

    const collapseAll = () => {
        setExpandedRows(null);
        toast.current.show({ severity: 'success', summary: 'All Rows Collapsed', life: 3000 });
    };

    const customer1TableHeader = (
        <div className="table-header">
            Listado de Recibos 
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const customer2TableHeader = (
        <div className="table-header">
            List of Customers
            <span className="p-input-icon-left">
                <i className="pi pi-search" />
                <InputText value={globalFilter2} onChange={(e) => setGlobalFilter2(e.target.value)} placeholder="Buscar..." />
            </span>
        </div>
    );

    const bodyTemplate = (data, props) => {
        return (
            <>
                <span className="p-column-title">{props.header}</span>
                {data[props.field]}
            </>
        );
    };

    const linkBodyTemplate = (data) => {
        return (
            <>
                <span className="p-column-title">Recibo</span>
                <button type="button" className="p-link" onClick={() => verRecibo(data.recibo)}>
                    <img src="assets/images/icon_01.png" alt={data.recibo} width={30} height={20} />
                    {/* <span style={{ marginLeft: '.5em', verticalAlign: 'middle' }} className="image-text">{data.recibo}</span> */}
                </button>
            </>
        );
    };

    const countryBodyTemplate = (data) => {
        return (
            <>
                <span className="p-column-title">Country</span>
                <img src="assets/demo/images/flags/flag_placeholder.png" alt={data.country.name} className={`flag flag-${data.country.code}`} width={30} height={20} />
                <span style={{ marginLeft: '.5em', verticalAlign: 'middle' }} className="image-text">{data.country.name}</span>
            </>
        );
    };

    const representativeBodyTemplate = (data) => {
        return (
            <>
                <span className="p-column-title">Representative</span>
                <img alt={data.representative.mes} src={`assets/demo/images/avatar/${data.representative.image}`} width="32" style={{ verticalAlign: 'middle' }} />
                <span style={{ marginLeft: '.5em', verticalAlign: 'middle' }} className="image-text">{data.representative.mes}</span>
            </>
        );
    };

    const statusBodyTemplate = (data) => {
        return (
            <>
                <span className="p-column-title">Status</span>
                <span className={`customer-badge status-${data.status}`}>{data.status}</span>
            </>
        )
    };

    const activityBody = (data) => {
        return (
            <>
                <span className="p-column-title">Activity</span>
                <ProgressBar value={data.activity} showValue={false} />
            </>
        )
    };

    const buttonFirmado = (data) => {
        return(
            <>
                <span className="p-column-title">Firmado</span>
                <Button type="button" icon="pi pi-check-square" className={(data.firmado ==="S" ? "p-button-primary" : "p-button-secondary")}  ></Button>
            </>
        )
    };


    const buttonRecibo = (data) => {
        return(
            <>
                <span className="p-column-title">Visto</span>
                {/* <Button type="button" icon="pi pi-check-square" className={(data.mes ==="2021-10" ? "p-button-primary" : "p-button-secondary")} ></Button> */}
                <Button type="button" icon="pi pi-check-square" className={(data.visualizado ==="S" ? "p-button-primary" : "p-button-secondary")} ></Button> 
            </>
        )
    };


   

    const buttonVerRecibo = (data) => 
    {
        return(
            <>
                <span className="p-column-title">Recibo</span>
                <Button type="button" icon="pi pi-file-pdf" className={"p-button-danger"} onClick={() => verRecibo(data.recibo)}></Button>
            </>
        )
    };

    
    const buttonVerReciboMobile = (data) => 
    {
        return(
            <>
                <span className="p-column-title">Recibo</span>
                <Button type="button" icon="pi pi-file-pdf" className={"p-button-danger"} onClick={() => verRecibo(data.recibo)}></Button>
            </>
        )
    };


    const productsTableHeader = (
        <div className="table-header-container">
            <Button icon="pi pi-plus" label="Expand All" onClick={expandAll} className="p-mr-2" />
            <Button icon="pi pi-minus" label="Collapse All" onClick={collapseAll} />
        </div>
    );


     // if(isSidebarVisible && isMobile.any() && !event.item.items) {
    //     setSidebarActive(false);
    // }

    return (
        <div className="p-grid table-demo">
            <div className="p-col-12">
                <div className="card">
                    <h5>Recibos</h5>
                    {/* <p>Pagination, sorting, filtering and checkbox selection.</p> */}
                    <DataTable value={recibos} paginator className="p-datatable-customers" rows={12} dataKey="id" rowHover selection={selectedCustomers} onSelectionChange={(e) => setSelectedCustomers(e.value)}
                        globalFilter={globalFilter1} emptyMessage="Buscar..." loading={loading1} header={customer1TableHeader} sortField="mes" sortOrder={-1} >
                        {/* <Column selectionMode="multiple" headerStyle={{ width: '3em' }}></Column> */}
                        {/* <Column field="mes" header="Recibo" sortable headerStyle={{ width: '15rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible', justifyContent: 'center' }} body={buttonVerRecibo}></Column> */}
                        <Column field="mes" header="Recibo"  body={isMobile.any() ? buttonVerReciboMobile : buttonVerRecibo}></Column>
                        <Column field="mes" header="Mes" sortable body={bodyTemplate}></Column>
                        
                        {/* <Column field="recibo" header="Recibo" sortable body={bodyTemplate}></Column> */}
                        {/* <Column field="recibo" header="Visualizar" sortable body={linkBodyTemplate}></Column> */}
                        {/* <Column field="recibo" header="Country" sortable body={countryBodyTemplate}></Column>
                        <Column field="firmado" header="Representative" sortable body={representativeBodyTemplate}></Column>
                        {/* <Column field="date" header="Date" sortable body={bodyTemplate}></Column> */}
                        {/* <Column field="status" header="Status" sortable body={statusBodyTemplate}></Column>  */}
                        
                        <Column field="mes" header="Firmado"  body={buttonFirmado}></Column>
                        <Column field="mes" header="Visualizado"    body={buttonRecibo}></Column>
                        <Column field="publicado" header="Publicado" sortable body={bodyTemplate}></Column>
                    </DataTable>
                </div>
            </div>

            <Dialog
                showHeader={false}
                closable={false}
                visible={reciboDialogVisible}
                style={{ width: '100vw', height: '100vh', maxHeight: '100vh', margin: 0, top: 0, left: 0 }}
                className="p-dialog-recibo"
                modal
                closeOnEscape
                dismissableMask
                onHide={cerrarRecibo}
                contentStyle={{ height: '100%', padding: 0, overflow: 'hidden', position: 'relative' }}
            >
                {reciboSeleccionado ? (
                    <iframe
                        title="Recibo"
                        src={reciboSeleccionado}
                        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
                    />
                ) : (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', background: '#525659', color: '#fff' }}>
                        Cargando recibo...
                    </div>
                )}
                <div style={{
                    position: 'absolute', left: '.75rem', top: '50%', transform: 'translateY(-50%)',
                    background: 'rgba(33,37,41,.85)', padding: '.5rem', borderRadius: '2rem', zIndex: 1100
                }}>
                    <Button type="button" icon="pi pi-times" className="p-button-rounded p-button-secondary" onClick={cerrarRecibo} />
                </div>
            </Dialog>
        </div>
    )
}
